<roots-page-header title="Weather" toolTip="Weather readings from the configured EarthScout weather station."
  [loading]="loading || loadingScouts" (refresh)="refresh()"></roots-page-header>
<div class="weather-workspace">
  <section class="weather-selector">
    <div><h2>Select a weather Scout</h2><p>Choose a Scout with a weather sensor to view its readings.</p></div>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Scout</mat-label>
      <mat-select [(ngModel)]="selectedScoutName" (selectionChange)="getScout($event.value)" [disabled]="loadingScouts">
        @for (item of availableScouts; track item.id) { <mat-option [value]="item.name">{{ item.name }}</mat-option> }
      </mat-select>
    </mat-form-field>
  </section>
  @if (errorMessage && !loading && !loadingScouts) {
    <section class="weather-empty" role="alert"><mat-icon>cloud_off</mat-icon><h2>Weather unavailable</h2>
      <p>{{ errorMessage }}</p><button mat-stroked-button (click)="refresh()">Try again</button>
    </section>
  }
  @if (scout != null) {
    <section class="weather-station">
      <div class="station-heading"><span class="weather-icon"><mat-icon>cloud_queue</mat-icon></span>
        <div><div class="weather-eyebrow">Weather station</div><h2>{{ scout.name }}</h2><p>Current sensor readings</p></div>
      </div>
      <span class="station-code">{{ scout.code }}</span>
    </section>
    <div class="weather-readings">
      <section class="weather-temperature weather-metric">
        <mat-icon aria-hidden="true">thermostat</mat-icon><h3>Air temperature</h3><div class="temperature-value">{{ airTemp || '—' }}</div>
        <p>Measured at this station</p>
      </section>
      <section class="weather-metric"><mat-icon aria-hidden="true">air</mat-icon><h3>Wind</h3>
        <div class="metric-value">{{ windSpeedCombinedNE || '—' }}</div><p>Direction: {{ windDirection || '—' }}</p>
      </section>
      <section class="weather-metric"><mat-icon aria-hidden="true">water_drop</mat-icon><h3>Precipitation</h3>
        <div class="metric-value">{{ precipitation || '—' }}</div>
      </section>
      <section class="weather-metric"><mat-icon aria-hidden="true">speed</mat-icon><h3>Barometric pressure</h3>
        <div class="metric-value">{{ barometricPressure || '—' }}</div>
      </section>
      <section class="weather-metric"><mat-icon aria-hidden="true">wb_sunny</mat-icon><h3>Shortwave radiation</h3>
        <div class="metric-value">{{ shortwaveRadiation || '—' }}</div>
      </section>
    </div>
    @if (!hasReadings && !loading) {
      <p class="weather-notice">Weather readings are not available for this station yet.</p>
    }
  } @else if (!loading && !loadingScouts && !errorMessage) {
    <section class="weather-empty"><mat-icon>cloud_off</mat-icon><h2>{{ availableScouts.length ? 'Choose a weather Scout' : 'No Scouts available' }}</h2>
      <p>Select a Scout above to load its weather readings.</p>
      <button mat-stroked-button (click)="refresh()">Refresh weather</button>
    </section>
  } @else if (loading || loadingScouts) {
    <section class="weather-empty" role="status"><h2>Loading weather…</h2><p>Getting the latest station readings.</p></section>
  }
</div>
